import { request } from '@/utils'

export default {
  // 日志统计总览查询
  statisticsSummary: (data: Recordable) => request.post('/ops/log/statistics/statisticsSummary', data),
  // 日志统计查询
  statisticsPageList: (data: Recordable) => {
    const params = {
      ...data.body,
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
    }
    return request.post('/ops/log/statistics/statisticsPageList', params)
  },
  // 日志统计明细查询
  statisticsDetailPageList: (data: Recordable) => {
    const params = {
      ...data.body,
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
    }
    return request.post('/ops/log/statistics/statisticsDetailPageList', params)
  },
  // 获取部门下所有的人员信息
  getAllUserByDeptId: (data: Recordable) => request.post('/ops/attendance/user/getAllUserByDeptId', data),
  // 获取当前人可以查询的所有部门信息
  getAllDeptInfoByUser: (params: Recordable) => request.get('/ops/attendance/user/getAllDeptInfoByUser', { params }),
  // 导出日志统计查询
  exportStatisticsPageList: (data?: any) =>
    request.post(`/ops/log/statistics/exportStatisticsPageList`, data, { responseType: 'blob', timeout: 30 * 60 * 1000 }),
  // 导出日志统计明细查询
  exportStatisticsDetailPageList: (data?: any) =>
    request.post(`/ops/log/statistics/exportStatisticsDetailPageList`, data, { responseType: 'blob', timeout: 30 * 60 * 1000 }),
  exportStatisticsDetailStatusPageList: (data?: any) =>
    request.post(`/ops/log/statistics/exportStatisticsStatusDetailPageList`, data, { responseType: 'blob', timeout: 30 * 60 * 1000 }),
  // 获取日志详情
  getLogDetail: (id: string) => request.get(`/ops/log/operation/getLogDetail/${id}`),
  // 获取当前用户相关项目
  getAllProjectOfCurrentUser: () => request.get('/ops/log/userinfo/getAllProjectOfCurrentUser'),
  // 获取当前用户相关任务
  getAllOpsTaskOfCurrentUser: (projectId?: string) => request.get(`/ops/log/userinfo/getAllOpsTaskOfCurrentUser?projectId=${projectId}`),
  // 获取当前用户相关客户单位
  getAllCustomerUnitOfCurrentUser: (projectId?: string) =>
    request.get(`/ops/log/userinfo/getAllCustomerUnitOfCurrentUser?projectId=${projectId}`),
  // 获取任务相关的所有人员信息
  getUserOfOpsTask: (taskId?: string) => request.get(`/ops/log/userinfo/getUserOfOpsTask?taskId=${taskId}`),
  // 获取任务日志主题
  getOpsLogTitle: (data: Recordable) => request.post('/ops/log/ops_log/getOpsLogTitle', data),
  // 写日志
  writeLog: (data: Recordable) => request.post('/ops/log/operation/writeLog', data),
  // 写日志
  getTemplateDetail: (templateId: string) => request.get(`/ops/log/template/getDetail/${templateId}`),
  // 获取所有日志模板的下拉框
  getTemplateSelectByCurrentUser: () => request.get('/ops/log/template/getTemplateSelectByCurrentUser'),

  // 通过用户和日期获取日志
  getLogDetailByUserAndDate: (data: Recordable) => request.post('/ops/log/operation/getLogDetailByUserAndDate', data),

  // 评论相关API
  commentPageList: (id: string, params: { pageSize: number; pageNumber: number }) =>
    request.post(`/ops/log/operation/commentPageList/${id}`, params),

  addComment: (data: Recordable) => request.post('/ops/log/operation/comment', data),

  delComment: (id: string) => request.post('/ops/log/operation/delComment', null, { params: { id } }),

  postLike: (params: { id: string }) => request.post('/ops/log/operation/postLike', null, { params }),

  // 日志评价相关API
  logLike: (logId: string) => request.get(`/ops/log/operation/logLike/${logId}`),

  logDislike: (logId: string) => request.get(`/ops/log/operation/logDislike/${logId}`),

  getLogGiveALike: (logId: string) => request.get(`/ops/log/operation/getLogGiveALike/${logId}`),
}
